export const START_ACTION = 'START_ACTION';
export const STOP_ACTION = 'STOP_ACTION';
export const REFRESH_ACTION_START = 'REFRESH_ACTION_START';
export const REFRESH_ACTION_STOP = 'REFRESH_ACTION_STOP';
export const SET_REQUEST_RESULT = 'SET_REQUEST_RESULT';
export const SET_ACCESS_DENIED = 'SET_ACCESS_DENIED';
export const REMOVE_BLOCKED = 'REMOVE_BLOCKED';
export const START_OVERLAY_LOADER = 'START_OVERLAY_LOADER';
export const STOP_OVERLAY_LOADER = 'STOP_OVERLAY_LOADER';